export default {
  slug: "wisdom-tooth-removal-in-guwahati",
  title: "Wisdom Tooth Removal in Guwahati",
  subtitle:
    "Safe & Painless Disimpaction Surgery – Advanced care for pain-free healing and long-term oral health",

  heroImage:
    "/dental-services/wisdom-teeth-removal/impacted-tooth-in-guwahati.webp",

  sections: [
    {
      type: "text",
      heading: "Wisdom Tooth Removal (Disimpaction Surgery)",
      content: `
Wisdom tooth removal, also known as disimpaction, is a minor surgical procedure performed to remove impacted or partially erupted third molars. 
These teeth often do not have enough space to grow properly, leading to pain, swelling, infection, and damage to nearby teeth.

At Magnum Dental Clinic, Guwahati, we provide safe, gentle, and advanced wisdom tooth removal using modern surgical techniques for faster healing and maximum comfort.
      `,
    },

    {
      type: "image",
      images: [
        "/dental-services/wisdom-tooth-removal.webp",
        "/dental-services/wisdom-teeth-removal/wisdom-tooth-extraction-in-guwahati.webp",
        "/dental-services/wisdom-teeth-removal/painless-extraction-in-guwahati.png",
      ],
      caption: "Images are for illustrative purposes only",
    },

    {
      type: "text",
      heading: "What Is Disimpaction?",
      content: `
Disimpaction is the surgical removal of a tooth that is trapped inside the jawbone or gums and unable to erupt normally. This condition is most commonly seen with wisdom teeth.

**Impacted wisdom teeth can:**
✔ Cause severe pain  
✔ Lead to swelling and infection  
✔ Damage nearby teeth  
✔ Create gum problems  
✔ Cause jaw stiffness  
✔ Result in cyst formation  

Early removal helps prevent serious complications and long-term damage.
      `,
    },

    {
      type: "text",
      heading: "When Do You Need Wisdom Tooth Removal?",
      content: `
A dentist or oral surgeon can clinically confirm if your wisdom tooth needs removal. 
You should visit a dentist immediately if you experience:

✔ Pain at the back of the mouth  
✔ Swollen or bleeding gums  
✔ Difficulty opening the mouth  
✔ Bad breath or persistent bad taste  
✔ Repeated food lodgement  
✔ Jaw pain or headache  
✔ Facial swelling  
✔ Infection or pus discharge  

Ignoring impacted wisdom teeth can lead to serious oral infections.
      `,
    },

    {
      type: "text",
      heading: "Wisdom Tooth Removal Procedure At Magnum Dental Clinic",
      content: `
At Magnum Dental Clinic, Guwahati, we follow a precise and comfortable treatment process:

1. Clinical examination & digital X-ray  
2. Local anesthesia (area completely numbed)  
3. Gentle surgical removal of the tooth  
4. Cleaning of the surgical area  
5. Suturing (if required)  
6. Post-operative care instructions  

The procedure is quick, safe, and performed with complete care.
      `,
    },

    {
      type: "text",
      heading: "Is Wisdom Tooth Removal Painful?",
      content: `
No. The procedure is performed under local anesthesia, making it comfortable and pain-free. You may feel slight pressure, but no pain.

After the surgery, mild discomfort, swelling, or stiffness is normal and can be easily managed with prescribed medications.
      `,
    },

    {
      type: "text",
      heading: "Recovery After Wisdom Tooth Removal",
      content: `
Most patients recover within 3–7 days, while complete healing may take a few weeks.

We provide detailed aftercare instructions including:
✔ What to eat after surgery  
✔ How to clean the area  
✔ Swelling control tips  
✔ Pain management guidance  
✔ Important do’s and don’ts
      `,
    },

    {
      type: "text",
      heading: "Benefits of Wisdom Tooth Removal",
      content: `
✔ Relieves pain and pressure  
✔ Prevents infection and swelling  
✔ Protects nearby teeth  
✔ Improves oral hygiene  
✔ Prevents cysts and bone damage  
✔ Improves jaw comfort and function
      `,
    },

    {
      type: "text",
      heading: "Why Choose Magnum Dental Clinic for Wisdom Tooth Removal in Guwahati?",
      content: `
✔ Experienced oral surgeons  
✔ Advanced surgical techniques  
✔ Painless and gentle procedures  
✔ Strict sterilization protocols  
✔ Affordable treatment options  
✔ Personalized patient care
      `,
    },
  ],

  faqs: [
    {
      q: "How long does wisdom tooth surgery take?",
      a: "Usually 30–60 minutes, depending on the complexity of the impaction.",
    },
    {
      q: "Can I eat after wisdom tooth removal?",
      a: "Yes, soft foods are recommended for the first 24–48 hours.",
    },
    {
      q: "Will there be swelling after surgery?",
      a: "Mild swelling is normal and usually subsides within 2–3 days.",
    },
    {
      q: "When can I return to work?",
      a: "Most patients resume normal activities within 1–2 days.",
    },
    {
      q: "Are stitches always required?",
      a: "Not always. It depends on the type and depth of impaction.",
    },
  ],

  cta: {
    heading: "Book Wisdom Tooth Removal in Guwahati Today",
    description: `
If you are experiencing pain or discomfort due to a wisdom tooth, don’t delay treatment.

📍 Location: First Floor, Global Tower, Near Mangalam Grand, Pathar Quarry, VIP Road, Guwahati, Assam

📞 Call at 8638940021 to book your appointment

🦷 Gentle surgery. Safe hands. Quick recovery.
    `,
    buttonText: "Book Wisdom Tooth Consultation",
    link: "/book-appointment-dental-clinic-guwahati",
  },
};
